import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { Providers } from '@/app/providers';
import { applyBundledTheme } from '@/shared/config/theme/apply-theme';
import '@/app/styles.css';

// §7.3: paint with the bundled default BEFORE React mounts, so the first frame is
// already themed and the fetched theme replaces it a moment later.
applyBundledTheme();

const container = document.getElementById('root');

if (!container) {
  // Thrown rather than silently doing nothing: an empty page with no error in the
  // console is the hardest kind of failure to diagnose.
  throw new Error('#root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <Providers>
      <App />
    </Providers>
  </StrictMode>,
);
